import fetcher from 'features/shared/utils/fetcher'

export async function getCountries() {
    return await fetcher.get('/countries')
  }
  